import React, {Component} from 'react'
import BasketDetailPage from "./BasketDetailPage"

class BasketDetailPageContainer extends Component {
    _parseBasketId = () => {
        const {id} = this.props.match.params

        return id
    }

    render() {
        const id = this._parseBasketId()

        return (
            <div className="BasketDetailPageContainer">
                <div className='container-fluid min-vh-100 bg-white shadow-sm pt-3'>
                    <BasketDetailPage id={id}/>
                </div>
            </div>
        )
    }
}

export default BasketDetailPageContainer
